import { Controller } from "@hotwired/stimulus"
import { toggleClass } from "../lib/helpers"

export default class extends Controller {
  static targets = ["content"]

  connect() {
    this.syncExpanded()
  }

  toggle(e) {
    e.preventDefault()
    toggleClass(this.contentTargets, "d-none")
    this.syncExpanded()
  }

  syncExpanded() {
    // The environment banner hangs the action off its own root and toggles
    // itself away, so there is no separate trigger to label there.
    const trigger = this.element.querySelector("[data-action*='show-and-hide#toggle']")
    if (!trigger || !this.hasContentTarget) return

    trigger.setAttribute("aria-expanded", !this.contentTarget.classList.contains("d-none"))
  }
}
